import React, { useEffect, useState } from 'react'

import { useSelector } from 'react-redux'
import { EditText } from 'react-edit-text';

import Correct from '../../../../assets/icons/correct.svg'
import CorrectGreen from "../../../../assets/icons/correctGreen.svg"
import useWindowDimensions from '../../../../hooks/useWindowDimensions';

export default function Answer({ isTrue, setTrue, setFalse, styles, handleClick, handleButtonClick, isTrueanswer, inputColor }) {

   const { modalOpen: previewModalOpen, showAnswers, isMobile } = useSelector(state => state.preview);
   const [hover, setHover] = useState(false)
   const [trueCorrect, setTrueCorrect] = useState(false)
   const [falseCorrect, setFalseCorrect] = useState(false)
   const { width } = useWindowDimensions();

   const onButtonClick = (e) => {
      isTrue ? setTrue() : setFalse()
      handleButtonClick(e)
   }

   const onClick = e => {
      isTrue ? handleClick(e, true) : handleClick(e, false)
   }

   useEffect(() => {
      if (isTrue) {
         if (previewModalOpen && !showAnswers) {
            setTrueCorrect(false)
         } else {
            isTrueanswer ? setTrueCorrect(true) : setTrueCorrect(false)
         }
      } else {
         if (previewModalOpen && !showAnswers) {
            setFalseCorrect(false)
         } else {
            !isTrueanswer ? setFalseCorrect(true) : setFalseCorrect(false)
         }
      }
   }, [isTrueanswer, showAnswers])

   return (
      <div className={`col-sm-12 ${isMobile && previewModalOpen && width > 1275 ? 'col-lg-12  col-md-12 ' : 'col-lg-6  col-md-6 '} `}
         style={{ marginBottom: '1.25rem', display: 'flex', alignItems: 'center', justifyContent: "center", ...styles.answerBox }}>
         <div className='answer_icon_container'
            onClick={isTrue ? setTrue : setFalse}>
            {
               isTrue ?
                  (trueCorrect ? <img src={CorrectGreen} /> : <img src={Correct} />)
                  :
                  (falseCorrect ? <img src={CorrectGreen} /> : <img src={Correct} />)
            }
         </div>
         <div className='answerBox' style={{ ...styles.answer, ...(hover ? styles.answerHover : null), marginBottom: 0 }}
            onClick={e => onButtonClick(e)}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}>
            <div onClick={e => onClick(e)} style={{ display: 'inline-block', }} >
               <EditText
                  value={isTrue ? "True" : "False"}
                  className="editable_text box"
                  style={{
                     wordBreak: 'break-all', padding: '0 0.2rem',
                     minWidth: '8px', backgroundColor: 'transparent',
                     textAlign: 'center',
                     color: inputColor
                  }}
                  readonly={true} />
            </div>
         </div>
      </div>
   )
}
